export default "__VITE_ASSET__cb8a38e4__"